import React from 'react';

import { getBenchmarkName, benchmarkSorter } from '../../../helpers/nameHelpers';
import * as helpers from '../portfolioHelpers';
import moment from 'moment';

import styled from 'styled-components';

const Td = styled.td`
@media screen{
    white-space nowrap;
}
`;


function getBenchmarkRow(benchmark, currencyType) {

    return <tr key={benchmark.name}>
        <Td>{getBenchmarkName(benchmark.name, currencyType)}</Td>
        <Td>{moment(benchmark.startDate).format('MMMM Do, YYYY')}</Td>
        <Td>{helpers.formatCell(benchmark.startingValue, '$')}</Td>
        <Td>{moment(benchmark.endDate).format('MMMM Do, YYYY')}</Td>
        <Td>{helpers.formatCell(benchmark.managementFeesPaid, '$')}</Td>
        <Td>{helpers.formatCell(benchmark.contributions, '$')}</Td>
        <Td>{helpers.formatCell(benchmark.withdrawls, '$')}</Td>
    </tr>
}

const Table = (props) => {

    const { portfolio } = props;
    const { reportData } = portfolio;

    const currencyType = portfolio.portfolio.data.currencyType;

    return <div>
        <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
            <thead>
                <tr>
                    <th>Portfolio Information Table 1</th>
                    <th colSpan={3}>Analysis Period</th>
                    <th rowSpan={2}>Management Fees Paid from Portfolio</th>
                    <th colSpan={2}>Total Portfolio Transfers</th>
                </tr>
                <tr>
                    <th>Client Portfolios</th>
                    <th>Starting Date</th>
                    <th>Starting Portfolio Value</th>
                    <th>Closing Date</th>
                    {/* <th>Paid from Portfolio</th> */}
                    <th>Contributions</th>
                    <th>Withdrawals</th>
                </tr>
            </thead>
            <tbody>
                {getBenchmarkRow(reportData.portfolio, currencyType)}
                <tr>
                    <td colSpan={21} style={{ fontWeight: 'bold', paddingTop: 20 }}>Client Benchmarks for {reportData.portfolio.name}</td>
                </tr>
                {/* {reportData.benchmarks.filter(e => e.name === 'clientSpecified').map(benchmark => { return getBenchmarkRow(benchmark) })} */}
                {reportData.benchmarks.sort(benchmarkSorter).filter(e => (e.selected || (e.name === 'clientSpecified' || e.name === 'equalWeight'))).map(benchmark => { return getBenchmarkRow(benchmark,currencyType) })}
            </tbody>
        </table>
    </div>
};

export default Table;


// WEBPACK FOOTER //
// ./src/portfolio/components/ReportTables/InformationTable1.js